import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-view-model',
  templateUrl: './login-view-model.component.html',
  styleUrls: ['./login-view-model.component.css']
})
export class LoginViewModelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
